import {
  FETCHING_PALETTE_IDS_REQUEST, FETCHING_PALETTE_IDS_SUCCEEDED, FETCHING_PALETTE_IDS_FAILED,
  UPDATE_BRANDKIT_ENABLE_TOGGLE_REQUEST, UPDATING_BRANDKIT_ENABLE_TOGGLE_SUCCEEDED, UPDATING_BRANDKIT_ENABLE_TOGGLE_FAILED,
  CREATE_EDITOR_BRAND_COMPONENT_REQUEST,
  CREATE_EDITOR_BRAND_MEDIA_REQUEST,
  CREATING_EDITOR_BRAND_COMPONENT_FAILED,
  CREATING_EDITOR_BRAND_COMPONENT_SUCCEEDED,
  CREATING_EDITOR_BRAND_MEDIA_FAILED,
  CREATING_EDITOR_BRAND_MEDIA_SUCCEEDED,
  INVALIDATE_BRAND_ELEMENTS,
} from 'constants/actionTypes.jsx';

import { combineReducers } from 'redux';

import { brandKitMediaReducer } from './mediaReducer';
import { brandKitIconsReducer } from './iconsReducer';
import { brandKitColorsReducer } from './colorsReducer';
import { brandKitTextReducer } from './textReducer';
import { brandKitButtonsReducer } from './buttonReducer';
import { brandKitComponentsReducer } from './componentsReducer';
  
  const initialState = {
    loading: false,
    items: [],
    brandKit: {
      item: null,
      loading: false,
      creating: false,
      updating: false
    },
    createBrandElement: {},
  }
  
  function activatedBrandKitReducer(state = initialState, action) {
    switch (action.type) {
      case FETCHING_PALETTE_IDS_REQUEST:
        return  {
          ...state,
          loading: true
        }
  
      case FETCHING_PALETTE_IDS_SUCCEEDED:
        var records = action.payload;
  
        return{
          ...state,
          loading: false,
          items: records?.response
        }
  
        case FETCHING_PALETTE_IDS_FAILED:
          return{
            ...state,
            loading: false,
            items: [],
            error: action.payload
          }

          case UPDATE_BRANDKIT_ENABLE_TOGGLE_REQUEST: {
            return {
              ...state,
              loading: true,
              updating: true
            }
          }
            
          case UPDATING_BRANDKIT_ENABLE_TOGGLE_SUCCEEDED: { 
            const {response} = action.payload;
  
            return {
              ...state,
              loading: false,
              updating: false,
            }
          }
            
          case UPDATING_BRANDKIT_ENABLE_TOGGLE_FAILED: {
            return {
              ...state,
              updating: false,
              loading: false,
              error: action.payload.error[0]
            }
          }

          case CREATE_EDITOR_BRAND_MEDIA_REQUEST:
            case CREATE_EDITOR_BRAND_COMPONENT_REQUEST:
              return updateBrandElementOperation(state, action.payload.uid, {
                loading: true,
                error: false,
                success: false
              });
        
          case CREATING_EDITOR_BRAND_MEDIA_SUCCEEDED:
          case CREATING_EDITOR_BRAND_COMPONENT_SUCCEEDED:
            return updateBrandElementOperation(state, action.payload.uid, {
              loading: false,
              success: true,
              error: false,
            });
      
          case CREATING_EDITOR_BRAND_MEDIA_FAILED:
          case CREATING_EDITOR_BRAND_COMPONENT_FAILED:
            return updateBrandElementOperation(state, action.payload.uid, {
              loading: false,
              success: false,
              error: action.payload.error,
            });
      
          case INVALIDATE_BRAND_ELEMENTS: {
            const { createBrandElement } = state;
            const updatedBrandKit = { ...createBrandElement };
            delete updatedBrandKit[action.payload.uid];
      
            return {
              ...state,
              createBrandElement: updatedBrandKit,
            };
          }
  
      default:
        return state
    }
  }


function updateBrandElementOperation(state, uid, updates) {
  const current = state.createBrandElement?.[uid] || {};
  const next = { ...current, ...updates };

  return {
    ...state,
    createBrandElement: {
      [uid]: next,
    },
  };
}

  const brandKitReducer = combineReducers({
    activated: activatedBrandKitReducer,
    media: brandKitMediaReducer,
    icons: brandKitIconsReducer,
    colors: brandKitColorsReducer,
    text: brandKitTextReducer,
    buttons: brandKitButtonsReducer,
    components: brandKitComponentsReducer
  });
  
  export { brandKitReducer };